import { render, staticRenderFns } from "./AuthExpireReminder.vue?vue&type=template&id=bce572fa&scoped=true"
import script from "./AuthExpireReminder.vue?vue&type=script&lang=js"
export * from "./AuthExpireReminder.vue?vue&type=script&lang=js"
import style0 from "./AuthExpireReminder.vue?vue&type=style&index=0&id=bce572fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce572fa",
  null
  
)

export default component.exports